export default __webpack_public_path__ + "static/media/search-icon.526db5ed.svg";